import "@/App.css";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PartnersSection from "./components/PartnersSection";
import FlavorMenu from "./components/FlavorMenu";
import FancyNutsSection from "./components/FancyNutsSection";
import EventGallery from "./components/EventGallery";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]" data-testid="app-container">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <PartnersSection />
        <FlavorMenu />
        <FancyNutsSection />
        <EventGallery />
        <TestimonialsSection />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}

export default App;
